export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  LOGIN_WITH_SSO: '/api/auth/sso',
  LOGOUT: '/logout',
  UNSUBSCRIBE: '/unsubscribe',

  MY_EXCO_LANDING: '/my-exco/landing',
  EXPENSES_LANDING: '/expenses/landing',
  SALES_LANDING: '/sales/landing',
  WAIBI_LANDING: '/advanced-indicators/landing',
  TERMS_OF_USE_LANDING: '/terms-of-use/landing',
  TERMS_OF_SUBSCRIPTION: '/terms-of-subscription/landing',

  HELP: '/help',
  EXPENSES: '/expenses',
  DEBTORS: '/debtors',
  DEBTOR: '/debtors/:code',
  CREDITORS: '/creditors',
  CREDITOR: '/creditors/:code',
  EMPLOYEE_REGISTER_TITLE: '/employee-register',
  EMPLOYEE_REGISTER_FORM: '/employee-register/new',
  UPLOAD_DOCUMENTS: '/upload-documents',
  INVOICE_SEARCH: '/invoice-search',
  DOCUMENTS_CABINET: '/documents-cabinet',
  NOT_AUTHORIZED: '/not-authorized',
  CHANGE_PASSWORD: '/change-password',
  TEMPORARY_CHANGE_PASSWORD: '/temporary-change-password',
  FORGOT_PASSWORD: '/forgot-password',
  PASSWORD_SENT: '/password-sent',
  PASSWORD_CHANGED: '/password-changed',
  CONTACTS: '/contacts',
  MY_INFORMATION: '/my-information',
  TURNOVER: '/turnover',
  TREASURY: '/treasuryPage',
  HR: '/human-resources',
  STORE: '/store',
  CART: '/cart',
  ADDITIONAL_USERS: '/additional-users',
  NEWS: '/news',

  // Salaries module
  SALARIES_MAIN_PAGE: '/salaries',
  SALARIES_EMPLOYEES: '/salaries/employees',
  SALARIES_REWARDS: '/salaries/rewards',
  SALARIES_CALENDAR: '/salaries/calendar',
  SALARIES_COMPANY_SETTINGS: '/salaries/company-settings',
  SALARIES_SCHEDULE_EMPTY: '/salaries/company-settings/schedule/',
  SALARIES_COMPANY_SETTINGS_SCHEDULE:
    '/salaries/company-settings/schedule/:id?',
  SALARIES_COMPANY_SETTINGS_REWARD_CREATE: '/salaries/company-settings/rewards',
  SALARIES_COMPANY_SETTINGS_REWARD: '/salaries/company-settings/rewards/:id?',
};

export const EXTERNAL_ROUTES = {
  EXCO: 'https://exco.fr/',
  TWITTER: 'https://twitter.com/exco_france',
  LINKEDIN: 'https://www.linkedin.com/company/exco/mycompany/',
  YOUTUBE: 'https://www.youtube.com/channel/UCdLEx0TboPWBR7W-R5KDElg',
  EXCO_AGENCIES: 'https://exco.fr/cabinets/exco-fiduciaire-du-sud-ouest/',
  EXCO_CONTACT:
    'https://exco.fr/cabinets/exco-fiduciaire-du-sud-ouest/#contact',
  WAIBI_LOGIN: 'https://my-exco-fso.waibi.app/login#waibi_at=',
  QUESTIONS: 'https://aide.myexco.net/faq/fr-fr',
};
